import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Row, Col } from 'reactstrap';
import Accordion from '../../../components/Accordion';
import AccordionItem from '../../../components/Accordion/components/AccordionItem';

import AxisPosition from '../components/AxisPosition';
import BasePlate from '../components/BasePlate';
import BasePlateFactor from '../components/BasePlateFactor';
import PedestalDimensions from '../components/PedestalDimensions';
import SafetyBarrierDimensions from '../components/SafetyBarrierDimensions';
import SafetyBarrierObject from '../../../object-view/generators/safety-barrier/safety-barrier.object';
import StairsDimensions from '../components/StairsDimensions';
import WallDimensions from '../components/WallDimensions';
import { setGroundOptions } from '@reducers/options/ground/actions';
import { APP_TEXTS } from '@texts';
import { PerspectiveCameraTypes, setPerspectiveCameraType } from '@reducers/camera/actions';


const SafetyBarrier = (props) => (
  <Row>
    <Col sm="12">
      <Accordion className="application__accordion" appStatus={props.appStatus} onItemClick={ (id) => {
            if (id === "safety_barrier_dimensions" || id === "pedestal_dimensions")
              props.setPerspectiveCameraType(PerspectiveCameraTypes.zoom_out);
            else 
              props.setPerspectiveCameraType(PerspectiveCameraTypes.focus_base_plate);
      }}>
        <AccordionItem id="safety_barrier_dimensions" title={APP_TEXTS.SAFETY_BARRIER_DIMENSIONS_TITLE.Content}>
          <SafetyBarrierDimensions
            options={props.options}
            // onUpdate={props.onUpdate}
          />
        </AccordionItem>
        {props.options.object.type === SafetyBarrierObject.types.PEDESTAL && (
          <AccordionItem id="pedestal_dimensions" title={APP_TEXTS.PEDESTAL_DIMENSIONS_TITLE.Content}>
            <PedestalDimensions
              options={props.options}
              // onUpdate={props.onUpdate}
            />
          </AccordionItem>
        )}
        {props.options.object.type === SafetyBarrierObject.types.STAIRS && (
          <AccordionItem id="stairs_dimensions" title={APP_TEXTS.STAIRS_DIMENSIONS_TITLE.Content}>
            <StairsDimensions
              options={props.options}
              onUpdate={props.onUpdate}
              distanceUnit={props.distanceUnit}
            />
          </AccordionItem>
        )}
        {props.options.object.type === SafetyBarrierObject.types.BETWEEN_WALLS && (
          <AccordionItem id="wall_dimensions" title={APP_TEXTS.WALL_DIMENSIONS_TITLE.Content}>
            <WallDimensions
              options={props.options}
              onUpdate={props.onUpdate}
              distanceUnit={props.distanceUnit}
            />
          </AccordionItem>
        )}
        <AccordionItem id="base_plate" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_BASE_PLATE.Content}>
          <BasePlate />
        </AccordionItem>
        <AccordionItem id="axis_position" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_AXIS_POSITION.Content}>
          <AxisPosition
            options={props.options}
            // onUpdate={props.onUpdate}
          />
        </AccordionItem>
        <AccordionItem id="base_plate_factor" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_BASE_PLATE_FACTOR.Content}>
          <BasePlateFactor
            options={props.options}
            // onUpdate={props.onUpdate}
          />
        </AccordionItem>
      </Accordion>
    </Col>
  </Row>
);

SafetyBarrier.propTypes = {
  options: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
};

const mapState = state => ({
  options: state.options,
  type: state.main.appType,
  distanceUnit: state.main.units.distance
});

const mapDispatch = dispatch => ({
  onUpdate: (options) => { dispatch(setGroundOptions(options)); },
  setPerspectiveCameraType: (value) => {dispatch(setPerspectiveCameraType(value)); }
});

export default connect(mapState, mapDispatch)(SafetyBarrier);



// WEBPACK FOOTER //
// ./src/views/Dimension/SafetyBarrier/SafetyBarrier.js